/* unplugin-vue-components disabled */import script from "./list.vue?vue&type=script&setup=true&lang=ts"
export * from "./list.vue?vue&type=script&setup=true&lang=ts"

import "./list.vue?vue&type=style&index=0&id=5798759d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\17532\\Desktop\\school\\logistics-meet\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5798759d"]])

export default __exports__